import {mutation, query} from "@/graphql/client";
import {Booking, Jobsite, RegisterBookingDefault, RegisterBookingInput, ShiftType} from "@/graphql/generated/graphql";
import {kapitelDateString, kapitelDateTimeString} from "@/graphql/kapitelTypes";
import {graphql} from "@/graphql/generated";

export async function fetchRegisterBookingDefaults(): Promise<RegisterBookingDefault> {

    const result = await query(
        graphql(`
            
            query RegisterBookingDefaults {
                registerBookingDefaults {
                    jobsite {
                        ...JobsiteFragment
                    }
                    qualification {
                        id
                        label
                    }
                    shiftTimes {
                        type
                        begin
                        until
                    }
                }
            }
        `)
    );

    return result?.data?.registerBookingDefaults;
}


export type BookingInput = {
    date: kapitelDateString,
    begin: kapitelDateTimeString,
    until: kapitelDateTimeString,
    jobsite: {
        id: number
    },
    qualification: {
        id: number
    },
}
export const setRegisterBookings = async (newRegisterBookings: BookingInput[]):Promise<{ errors:string[], successfulBookings:Booking[] }> => {
    const MUTATION = graphql(`
        
        mutation SetRegisterBookings(
            $registerBookingInputs: [RegisterBookingInput!]!
        ) {
            setRegisterBookings(
                bookingInputs: $registerBookingInputs
            )
            {
                ...BookingFragment
            }
        }
    `);

    const registerBookingInputs: RegisterBookingInput[] = newRegisterBookings.map(b => {
        if(!b.jobsite.id){
            throw new Error("Jobsite id not defined")
        }

        if(!b.qualification.id){
            throw new Error("qualification id not defined")
        }

        return {
            begin: b.begin,
            until: b.until,
            jobsiteId: b.jobsite.id,
            qualificationId: b.qualification.id
        }
    })


    const result = await mutation(MUTATION, {
        registerBookingInputs: registerBookingInputs,
    }, false);

    const errors = result?.error?.graphQLErrors?.map((gqle:any) => gqle.message) || []

    const successfulBookings = result?.data?.setRegisterBookings || []

    return {successfulBookings,errors}
};


export interface shiftDate  {
    type: ShiftType,
    date: kapitelDateString
}

export const resolveJobsite = async (qString: string): Promise<Jobsite|null> => {

    const result = await query(
        graphql(`
            query ResolveJobsites (
                $q: String!
            ){
              resolvedJobsites (
                jobsiteQuery: $q
              ){
                  ...JobsiteFragment
              }
        }`),
        {
            q: qString
        }
    )

    return result?.data?.resolvedJobsites[0] ?? null
}
